import { ComponentType } from 'react';

import { BarChartSquare01Icon } from '@/components/icons/BarChartSquare01Icon';
import { IconProps } from '@/components/icons/CheckCircleIcon';
import { FileCheck02Icon } from '@/components/icons/FileCheck02Icon';
import { FilePlus03Icon } from '@/components/icons/FilePlus03Icon';
import { Grid03Icon } from '@/components/icons/Grid03Icon';
import { Link01Icon } from '@/components/icons/Link01Icon';
import { PresentationChart01Icon } from '@/components/icons/PresentationChart01Icon';
import { RefreshCw04Icon } from '@/components/icons/RefreshCw04Icon';
import { NotificationTrayActivityItem } from '@/modules/notifications/components/NotificationsTray/ActivitiesTab/ActivitiesTab';
import { ActivityStatus } from '@/modules/notifications/components/NotificationsTray/ActivitiesTab/ActivityItem';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';
import {
  WorkflowTracker,
  WorkflowTrackerKind,
  WorkflowTrackerStatus,
} from '@/types/schema';

function mapWorkflowTrackerStatusToActivityStatus(
  status: WorkflowTrackerStatus
): ActivityStatus {
  switch (status) {
    case WorkflowTrackerStatus.Started:
      return 'inProgress';
    case WorkflowTrackerStatus.Completed:
      return 'completed';
    case WorkflowTrackerStatus.Failed:
      return 'failed';
    default:
      return 'completed';
  }
}

function mapWorkflowTrackerKindToIcon(
  kind: WorkflowTrackerKind
): ComponentType<IconProps> {
  switch (kind) {
    case WorkflowTrackerKind.PresentationGeneration:
      return PresentationChart01Icon;
    case WorkflowTrackerKind.ProposalGeneration:
      return BarChartSquare01Icon;
    case WorkflowTrackerKind.DocumentExtraction:
    case WorkflowTrackerKind.DocumentSplitBinder:
      return FilePlus03Icon;
    case WorkflowTrackerKind.ManualAiDp:
    case WorkflowTrackerKind.AiSuggestionsV2EntityDetailsGeneration:
      return RefreshCw04Icon;
    case WorkflowTrackerKind.DocumentSummaryPromptTestRun:
      return FileCheck02Icon;
    case WorkflowTrackerKind.MemoGeneration:
      return FileCheck02Icon;
    case WorkflowTrackerKind.EstateSnapshotGeneration:
      return Grid03Icon;
    case WorkflowTrackerKind.AddeparCacheSync:
    case WorkflowTrackerKind.AddeparEntitySync:
    case WorkflowTrackerKind.BlackDiamondCacheSync:
    case WorkflowTrackerKind.BlackDiamondEntitySync:
    case WorkflowTrackerKind.EmoneyCacheSync:
    case WorkflowTrackerKind.EmoneyEntitySync:
    case WorkflowTrackerKind.OrionCacheSync:
    case WorkflowTrackerKind.OrionEntitySync:
      return Link01Icon;
    default:
      return Link01Icon;
  }
}

export function mapWorkflowTrackerToActivityItem(
  tracker: WorkflowTracker
): NotificationTrayActivityItem {
  return {
    id: tracker.id,
    Icon: mapWorkflowTrackerKindToIcon(tracker.kind),
    title: tracker.description ?? 'Unknown status',
    timestamp: tracker.endedAt ?? tracker.startedAt,
    status: mapWorkflowTrackerStatusToActivityStatus(tracker.status),
    failureMessage: tracker.failureReason ?? undefined,
    householdName: tracker.household?.displayName,
    householdPath: tracker.household
      ? getCompletePathFromRouteKey(ROUTE_KEYS.HOUSEHOLD_DETAILS_OVERVIEW, {
          householdId: tracker.household.id,
        })
      : undefined,
  };
}
